module.exports = __webpack_public_path__ + "img/innovative.3934bcec.svg";